import React, { Fragment, useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers'
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { payCodeInitialsForAdd,payCodeInitialsForUpdate } from './interfaces/payCodeClass';
import { getPayCodeDatatableAsync, resetSelectedRecordObjectInState, addPayCodeAsync, updatePayCodeAsync } from './payCodeSlice';
import Select, { StylesConfig } from 'react-select';
import fetchAPI from '../../../common/fetchAPI';
import * as yup from 'yup';
import { Formik } from 'formik';
import { ShowToast } from '../../../common/Toastr';
import { useTranslation } from 'react-i18next';

const PayCodeForm = (props: any) => {
    const [disabledCount, setDisabledCount] = useState(0)
    const { modelRef, t, oncloseModal } = props;
    const defaultFocusRef = useRef<HTMLInputElement>(null);
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(payCodeInitialsForAdd);
    const { selectedRecord,payCodeList, isLoading } = useAppSelector((state) => state.payCode);
    const dispatch = useAppDispatch();

    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(payCodeInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.IsDisabled = stateItem.IsDisabled === 'Yes' ? true : false;
            setCurrentFieldsData(stateItem);
        }
        else {
            setCurrentFieldsData(payCodeInitialsForAdd);
        }
        if (defaultFocusRef.current) {
            defaultFocusRef.current.focus();
        }
        calculatedDisabledValue();
    }, [selectedRecord])

    const handleSubmit = (values: any) => {
        if (Object.keys(selectedRecord).length > 0) {
            dispatch(updatePayCodeAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "200" ?
                        ShowToast("Pay Code update Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        else {
            dispatch(addPayCodeAsync(values))
                .unwrap()
                .then((originalPromiseResult) => {
                    originalPromiseResult.StatusCode === "201" ?
                        ShowToast("Pay Code Added Successfully", 'Success', "success", "toast-top-right") :
                        ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                })
                .catch((rejectedValueOrSerializedError) => {
                    ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                })
        }
        oncloseModal();
    }
    const calculatedDisabledValue = () => {
        if (payCodeList.length > 0) {
            let index = 0;
            payCodeList.forEach((value) => {
                if (value.IsDisabled.toString() == 'Yes') {
                    index = index + 1
                }
            });
            setDisabledCount(payCodeList.length - index);
        }
    }
    return (
        <>
            <Formik
                initialValues={currentFieldsData}
                enableReinitialize={true}
                onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
                validationSchema={yup.object().shape({
                    Name: yup
                        .string()
                        .label('Name')
                        .trim()
                        .required(t('Name is required')),
                        Code: yup
                        .string()
                        .label('Code')
                        .trim()
                        .required(t('Code is required'))     
                         })}>
                {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
                    <Fragment>
                        <form>
                            <div className='card-body'>
                                {isLoading ?
                                    <div className="col-md-12">
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            <span className='spinner-border spinner-border-md ms-2'></span>
                                        </span>
                                    </div>
                                    : <>
                                        <div className="modal" style={{ display: 'block' }}
                                        >
                                            <div className="modal-dialog">
                                                <div className="modal-content">
                                                    <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                                                        <h5 className="modal-title mainHeading">{Object.keys(selectedRecord).length > 0 ? t('Update') : t('Add')} {t('Pay Code')} </h5>
                                                        <div
                                                            className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                                            onClick={oncloseModal}
                                                        >
                                                            <KTSVG
                                                                path="/media/icons/duotune/arrows/arr061.svg"
                                                                className="svg-icon svg-icon-1x"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="modal-body">
                                                        <form className='form'>
                                                            <div className="mb-3">
                                                                <label className="fs-7 fs-7 fw-normal">{t('Name')}</label>
                                                                <input type="text" className="form-control fs-7 fw-normal" id='Name' value={values.Name} name='Name'
                                                                    onChange={handleChange('Name')}
                                                                    onBlur={() => setFieldTouched('Name')}
                                                                    style={{ color: '#172b4d' }}
                                                                    ref={defaultFocusRef}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            setFieldTouched('Name', true);
                                                                            handleSubmit();
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div style={{ paddingRight: 5, paddingBottom:5 }}>
                                                                {touched.Name && errors.Name &&
                                                                    <p className='errorMsg'>{errors.Name as string}</p>
                                                                }
                                                            </div>
                                                            <div className="mb-3">
                                                                <label className="fs-7 fs-7 fw-normal">{t('Code')}</label>
                                                                <input type="text" className="form-control fs-7 fw-normal" id='Code' value={values.Code} name='Code'
                                                                    onChange={handleChange('Code')}
                                                                    onBlur={() => setFieldTouched('Code')}
                                                                    style={{ color: '#172b4d' }}
                                                                    //ref={defaultFocusRef}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            e.preventDefault();
                                                                            setFieldTouched('Code', true);
                                                                            handleSubmit();
                                                                        }
                                                                    }}
                                                                />
                                                            </div>
                                                            <div style={{ paddingRight: 5, paddingBottom:5 }}>
                                                                {touched.Code && errors.Code &&
                                                                    <p className='errorMsg'>{errors.Code as string}</p>
                                                                }
                                                            </div>
                                                            <div className="mb-3">
                                                                <label className="fs-7 fs-7 fw-normal">{t('Description')}</label>
                                                                <input type="text" className="form-control fs-7 fw-normal" id='Description' 
                                                                value={values.Description} 
                                                                name='Description'
                                                                onChange={handleChange('Description')}                                                              
                                                                />
                                                            </div>
                                                            <div className="mb-3">
                                                                <label className="fs-7 fs-7 fw-normal">{t('Multiplier')}</label>
                                                                <input type="text" className="form-control fs-7 fw-normal" id='Multiplier' 
                                                                value={values.Multiplier} 
                                                                name='Multiplier'
                                                                onChange={handleChange('Multiplier')}                                                                   
                                                                />
                                                            </div>
                                                            {Object.keys(selectedRecord).length > 0 ? (
                                                                    disabledCount !== 1 ? <div className="mb-3" >
                                                                        <label className="fs-7 fw-normal mt-2">{t('Disabled')}</label>
                                                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                            <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                                onChange={handleChange('IsDisabled')}
                                                                            />
                                                                        </div>
                                                                    </div> : payCodeList.find(x => x.AccountPayCodeId === values.AccountPayCodeId)?.IsDisabled.toString() === "Yes" && (<div className="mb-3" >
                                                                        <label className="fs-7 fw-normal mt-2">{t('Disabled')}</label>
                                                                        <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                                                            <input className="form-check-input h-20px w-30px mt-2" type="checkbox" checked={values.IsDisabled} id="IsDisabled"
                                                                                onChange={handleChange('IsDisabled')}
                                                                            />
                                                                        </div>
                                                                    </div>)
                                                                ) : null}
                                                        </form>
                                                    </div>
                                                    <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary btn-bs-btn-font-weight btn-sm p-2 fs-7"
                                                            onClick={oncloseModal}
                                                        >
                                                            {t('Cancel')}
                                                        </button>
                                                        <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm p-2 fs-7" onClick={() => handleSubmit()} disabled={!isValid}>
                                                            {Object.keys(selectedRecord).length > 0 ? t('Update') : t('Save')}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </form>
                    </Fragment>
                )}
            </Formik>
        </>
    )
    // const { modelRef } = props;
    // const { t } = useTranslation();
    // const [currentFieldsData, setCurrentFieldsData] = useState<any>(payCodeInitialsForAdd);
    // const { selectedRecord, isLoading } = useAppSelector((state) => state.payCode);
    // const dispatch = useAppDispatch();
    // const [selectedOptionDropDown, setSelectedOptionDropDown] = useState<{ [object: string]: any }>();
    // const [selectedOptionCurrecny, setSelectedOptionCurrency] = useState<{ [object: string]: any }>();
    // const [SystemPaymentArray, SetSystemPaymentArray] = useState<any | ''>([]);
    // const [currencyArray, SetCurrencyArray] = useState<any | ''>([]);

    // useEffect(() => {
    //     let stateItem: any = {}
       
    //     if (Object.keys(selectedRecord).length > 0) {
    //         const tempObj: any = selectedRecord;
    //         Object.keys(payCodeInitialsForUpdate).map((item) => {
                
    //             return stateItem[item] = tempObj[item];
    //         })
    //         stateItem.IsDisabled = stateItem.IsDisabled === "Yes" ? true : false;
    //         setCurrentFieldsData(stateItem);
    //         console.log('payCodeInitialsForUpdate :',tempObj);
    //     }
    //     else {
           
    //         setCurrentFieldsData(payCodeInitialsForAdd);
    //     }
    // }, [selectedRecord])

    // const closeButtonRef = useRef<HTMLButtonElement | null>(null);


    // const handleSubmit = (values: any) => {
    //     if (Object.keys(selectedRecord).length > 0) {
    //          //console.log('For Update :', values);
    //         dispatch(updatePayCodeAsync(values))
    //             .unwrap()
    //             .then((originalPromiseResult) => {
    //                 ShowToast(t("Pay Code Updated Successfully"), 'Success', "success", "toast-top-right");
    //                 dispatch(getPayCodeDatatableAsync());
    //             })
    //             .catch((rejectedValueOrSerializedError) => {
    //                 ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
    //             })
    //     }
    //     else {
    //        // console.log('For Insert :', values);
    //         dispatch(addPayCodeAsync(values))
    //             .unwrap()
    //             .then((originalPromiseResult) => {
    //                 ShowToast("Pay Code Inserted Successfully", 'Success', "success", "toast-top-right");
    //                 dispatch(getPayCodeDatatableAsync());
    //             })
    //             .catch((rejectedValueOrSerializedError) => {
    //                 ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
    //             })
    //     }
    //     if (closeButtonRef.current) {
    //         closeButtonRef.current.click();
    //     }
    // }
    // const handleCloseOnClickEvent = () => {
    //     dispatch(resetSelectedRecordObjectInState());
    // }

    // return (
    //     <>
    //         <Formik
    //             initialValues={currentFieldsData}
    //             enableReinitialize={true}
    //             onSubmit={(values, action) => { handleSubmit(values); action.resetForm() }}
    //             validationSchema={yup.object().shape({
    //                 Name: yup
    //                     .string()
    //                     .label('Name')
    //                     .trim()
    //                     .required(t('Pay code name is required')),
    //                     Code: yup
    //                     .string()
    //                     .label('Code')
    //                     .trim()
    //                     .required(t('Pay code is required'))     
    //                      })}>
    //             {({ values, handleChange, errors, setFieldTouched, touched, isValid, handleSubmit }) => (
    //                 <Fragment>
    //                     <form>
    //                         <div className='card-body'>
    //                             {isLoading ?
    //                                 <div className="col-md-12">
    //                                     <span className='indicator-progress' style={{ display: 'block' }}>
    //                                         <span className='spinner-border spinner-border-md ms-2'></span>
    //                                     </span>
    //                                 </div>
    //                                 : <>
    //                                     <div className='row'>
    //                                         <div className="col-md-6 mb-3">
    //                                             <label className="form-label ">{t('Pay Code Name')}</label>
    //                                             <input type="text" className="form-control" id='Name' value={values.Name} name='Name'
    //                                                 onChange={handleChange('Name')}
    //                                                 onBlur={() => setFieldTouched('Name')}
    //                                             />
    //                                             <div style={{ paddingRight: 20 }}>
    //                                                 {touched.Name && errors.Name &&
    //                                                     <p className='errorMsg'>{errors.Name as string}</p>
    //                                                 }
    //                                             </div>
    //                                         </div>
    //                                         <div className="col-md-6 mb-3">
    //                                             <label className="form-label">{t('Code')}</label>
    //                                             <input type="text" className="form-control" id='Code' value={values.Code} name='PaidCodeThroughAccountCode'
    //                                                 onChange={handleChange('Code')}
    //                                                 onBlur={() => setFieldTouched('Code')}
    //                                             />
    //                                             <div style={{ paddingRight: 20 }}>
    //                                                 {touched.Code && errors.Code &&
    //                                                     <p className='errorMsg'>{errors.Code as string}</p>
    //                                                 }
    //                                             </div>
    //                                         </div>
    //                                     </div>
                                        
    //                                     <div className='row'>
    //                                         <div className="col-md-6 mb-3">
    //                                             <label className="form-label">{t('Description')}</label>
    //                                             <input type="text" className="form-control" id='Description' value={values.Description} name='Description'
    //                                                 onChange={handleChange('Description')}
    //                                                 onBlur={() => setFieldTouched('Description')}
    //                                             />
    //                                         </div>
    //                                         <div className="col-md-6 mb-3">
    //                                             <label className="form-label">{t('Multiplier')}</label>
    //                                             <input type="text" className="form-control" id='Multiplier' value={values.Multiplier} name='Multiplier'
    //                                                 onChange={handleChange('Multiplier')}
    //                                                 onBlur={() => setFieldTouched('Multiplier')}
    //                                             />
    //                                         </div>
    //                                     </div>
                                      
    //                                     <div className='row'>
    //                                         <div className="col-md-6 mb-2">
    //                                             {Object.keys(selectedRecord).length > 0 ? (
    //                                                 <div className="col-md-12">
    //                                                     <label className="form-label">{t('Disabled')}</label>
    //                                                     <div className="form-check form-switch form-check-custom form-check-solid me-10">
    //                                                         <input className="form-check-input h-20px w-30px" type="checkbox"
    //                                                             checked={values.IsDisabled} id="IsDisabled"
    //                                                             onChange={handleChange('IsDisabled')}
    //                                                         />
    //                                                     </div>
    //                                                 </div>
    //                                             ) : null}
    //                                         </div>
    //                                     </div>
    //                                 </>
    //                             }
    //                         </div>
    //                         <div className='card-footer pt-4 '>
    //                             <div className='d-flex flex-stack float-end'>
    //                                 <div className='d-flex align-items-center me-2'>
    //                                     <button
    //                                         ref={closeButtonRef}
    //                                         type="button"
    //                                         className="btn btn-light btn-sm me-2"
    //                                         id="kt_OffCanvas"
    //                                         onClick={handleCloseOnClickEvent}
    //                                     >
    //                                         {t('Close')}
    //                                     </button>

    //                                     <button type="button" data-kt-element='send' className="btn btn-light-primary btn-sm" onClick={() => handleSubmit()} disabled={!isValid}>
    //                                         {Object.keys(selectedRecord).length > 0 ? t('Update') : t('Add')} {t('Pay Code')}
    //                                     </button>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </form>
    //                 </Fragment>
    //             )}
    //         </Formik>
    //     </>
    // )

}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}
export default PayCodeForm